module.exports = __webpack_public_path__ + "static/media/humana.7adcfc4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/humana.png
// module id = 34
// module chunks = 0